import z from 'zod';
import { CLASSIFIERS_FORM_FIELDS } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/LegalPersonDetails/hook/types.ts';

export const ClassifiersFormShape = z.object({
	[CLASSIFIERS_FORM_FIELDS.display_name]: z.string().nullish(),
	[CLASSIFIERS_FORM_FIELDS.tags]: z.array(z.string()),
});
